import { FeedLiveItem } from '@/models/feedLive';
import { IFeedTeam } from '@/types';
import { FeedPregameItem } from '@/models/feedPregame';

export function useFeedTeamHandler(teamItems: Ref<Record<number, IFeedTeam>>) {
    function clearFeedTeam(): void {
        teamItems.value = {};
    }

    function addFeedTeam(feedLine: FeedLiveItem | FeedPregameItem): void {
        if (!(feedLine.teamHomeId.value in teamItems.value)) {
            teamItems.value[feedLine.teamHomeId.value] = {
                id: feedLine.teamHomeId.value,
                name: feedLine.teamHomeName.value,
            };
        }

        if (!(feedLine.teamAwayId.value in teamItems.value)) {
            teamItems.value[feedLine.teamAwayId.value] = {
                id: feedLine.teamAwayId.value,
                name: feedLine.teamAwayName.value,
            };
        }
    }

    function removeFeedTeam(feedLine: FeedLiveItem | FeedPregameItem): void {
        delete teamItems.value[feedLine.teamHomeId.value];
        delete teamItems.value[feedLine.teamAwayId.value];
    }

    return {
        clearFeedTeam,
        addFeedTeam,
        removeFeedTeam,
    };
}
